import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterMessageActivePicto extends pictoProps {
}

export interface FooterMessageActivePicto extends pictoState {
}

export class FooterMessageActivePicto extends Picto<FooterMessageActivePicto,FooterMessageActivePicto>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerMessagesActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterMessageActivePicto);
